import Component from "@glimmer/component"

export default class GoogleClassroomTopicMenuComponent extends Component {}
